import { Inject, Injectable } from '@angular/core';
import { defaultThemes } from '../../enums/themes.enum';
import { LocalStorageService } from '../local-storage/local-storage.service';
import { IScope } from 'angular';
import * as caslinkServices from 'src/app/modules/legacy/legacy-services';

@Injectable({
    providedIn: 'root'
})
export class ThemeService {
    private _isDarkTheme: boolean;

    public get isDarkTheme(): boolean {
        return this._isDarkTheme;
    }

    public set isDarkTheme(value) {
        if (typeof value === 'boolean') {
            this._isDarkTheme = value;
        }

        this._isDarkTheme = value.toString().toLowerCase() === 'true';
    }

    constructor(private localStorageService: LocalStorageService,
                @Inject(caslinkServices.ThemeProvider) private themeProvider: any,
                @Inject(caslinkServices.MdTheming) private $mdTheming: any,
                @Inject('$rootScope') private rootScope: IScope
    ) {
        //at this point we can not go to api yet so we load preference from local storage
        // look for theme key in storage, default is light theme
        this.isDarkTheme = localStorageService.get('theme') === 'dark';
        // class must be applied to body for snackBars and modals to work
        document.body.classList.add(this.getThemeName());

        this.setLegacyTheme();
    }


    public setDarkTheme(isDarkTheme: boolean): void {
        this.isDarkTheme = isDarkTheme;

        //update local storage
        this.localStorageService.set('theme', this.getThemeName());

        // class must be applied to body for snackBars and modals to work
        document.body.classList.remove(this.getOtherThemeName());
        document.body.classList.add(this.getThemeName());

        this.setLegacyTheme();
    }

    private setLegacyTheme() {
        const theme = this.getCasTheme();
        // TODO - fix it when it is actually needed
        // change rootScope current theme and set it to attribute
        // tslint:disable-next-line:no-string-literal
        this.rootScope['currentTheme'] = theme;
        this.themeProvider.setDefaultTheme(theme.name);

        this.rootScope.$applyAsync();
    }

    public getCasTheme() {
        return this.isDarkTheme ? defaultThemes.dark : defaultThemes.light;
    }

    /**
     * returns name of current caslink theme from caslink-themes package
     */
    public getCasThemeName() {
        return this.getCasTheme().name;
    }

    /**
     * Returns name of current theme
     */
    private getThemeName(): string {
        return this.getCasTheme().label;
    }

    /**
     * Returns name of opposite theme
     */
    private getOtherThemeName(): string {
        return this.isDarkTheme ? 'light' : 'dark';
    }
}
